module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!spectatorMode) { ;
__p += '\n    <div class="vertical-ruler"></div>\n    <div class=\'vertical-ruler-mask\'></div>\n';
 } ;
__p += '\n<div class="scene-area-container">\n    ';
 if (!spectatorMode) { ;
__p += '\n        <div class="horizontal-ruler-mask"></div>\n        <div class="horizontal-ruler"></div>\n    ';
 } ;
__p += '\n    <div class="widgets-boundary ' +
__e( widgetBoundaryClass ) +
'">\n        <div class="scene-loading-region"></div>\n        <div class="master-layer backdrop"></div>\n        <div class="widgets-container">\n            ';
 if (!spectatorMode) { ;
__p += '\n                <div class="container-border no-scale"></div>\n            ';
 } ;
__p += '\n            <div class="snap-container">\n                <div class="snap-replacement"><div></div></div>\n                <span class="snap-line vertical"></span>\n                <span class="snap-line horizontal"></span>\n                <div class="snap-cross"></div>\n            </div>\n            ';
 if (!spectatorMode) { ;
__p += '\n                <div class="guidelines-container"></div>\n            ';
 } ;
__p += '\n            <div class="scene-widget-collection-views-region-container"></div>\n        </div>\n    </div>\n</div>\n<div class="scene-footer">\n    <ul class="navigation">\n        ';
 if (!spectatorMode) { ;
__p += '\n            <li class="move-scene-backwards icon no-scale" title="Move scene backwards">&larr;</li>\n        ';
 } ;
__p += '\n        <li class="scene-index  no-scale"></li>\n        ';
 if (!spectatorMode) { ;
__p += '\n            <li class="move-scene-forwards icon no-scale" title="Move scene forwards">&rarr;</li>\n        ';
 } ;
__p += '\n    </ul>\n    <div class="actions no-scale">\n        ';
 if (!spectatorMode) { ;
__p += '\n            <span class="duplicate-scene icon" title="Duplicate scene"></span>\n            <span class="delete-scene icon" title="Delete scene"></span>\n        ';
 } ;
__p += '\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/SceneEditor.tpl
// module id = 3015
// module chunks = 0